/** Site setting: hide Street Number on address forms even if present in country address format. */
export function isHideStreetNumberEnabled(appConfig: { hideStreetNumber?: boolean } | undefined): boolean {
    return !!appConfig?.hideStreetNumber;
}
